module.exports = "https://trybtryb-legacy.web.app/img/dotted-special-desktop.d6db6570.svg";